import {getStore} from "../../../../redux/storeAccess";
import {musicHomeSlice} from "./musicHomeSlice";

export const musicHomeStore = {
  // State modifiers
  resetAndCloseSearch: () => {
    // clear search
    getStore().dispatch(musicHomeSlice.actions.resetFilterSearchReducer());
    // TODO: Not sure this line is a good idea. Stores probably should reference each other to avoid circular dependencies.
    //  Also, mobile.search value should probably be pulled through a store facade.
    const isMobileSearchMenuOpen = getStore().getState().mySongsPage.activeMenu?.includes('mobile.search');
    if (isMobileSearchMenuOpen) {
      // is open, close
      getStore().dispatch(musicHomeSlice.actions.removeActiveMenuReducer('mobile.search'));
    }
  },
  setSearchFieldFocus: (isFocused: boolean) => getStore().dispatch(musicHomeSlice.actions.setSearchFieldFocusReducer(isFocused)),
  setSearchFieldValue: (value: string) => getStore().dispatch(musicHomeSlice.actions.filterSearchSetValueReducer(value)),
  toggleMobileSearchControls: () => getStore().dispatch(musicHomeSlice.actions.toggleActiveMenuReducer('mobile.search')),

  // Getters
  doesMobileSearchHaveText: (): boolean => musicHomeSlice.selectors.doesMobileSearchFieldHaveTextSelector(getStore().getState()),
  getSearchText: (): string => musicHomeSlice.selectors.searchTextSelector(getStore().getState()),
  isMobileSearchActive: (): boolean => musicHomeSlice.selectors.isMobileSearchFieldActiveSelector(getStore().getState()),
  isSearchFieldFocused: (): boolean => musicHomeSlice.selectors.isSearchFieldFocusedSelector(getStore().getState()),
}